import AddMcqForm from "../../components/form/add-mcq-form";
import Header from '../../components/header';

const AddMcq = () => {

    return (
        <>
            <Header />
            <div className="container">
                <AddMcqForm />
            </div>
        </>
    )

}

export default AddMcq;